import { cn } from "@gettactic/helpers";
import * as SelectPrimitive from "@radix-ui/react-select";
import * as React from "react";
import "./office-select-item.css";
import { LabelWithHighlight } from "../../../data-display/labels/LabelWithHighlight/LabelWithHighlight";
import { SelectOfficeItemProps } from "./SelectOfficeItem";

import { OfficeIcon } from "../../../icons/TacticIcons/OfficeIcon";
import { FolderIcon } from "lucide-react";
import { TacticIconType } from "../../../icons/TacticIcons/tacticIcons.types";
import { HomeIcon } from "../../../icons/TacticIcons/HomeIcon";
import { OOOIcon } from "../../../icons/TacticIcons/OOOIcon";
import { LocationTypes, LocationVariants } from "./utils";
import { SelectItem } from "@cmp-src/primitives/Select";

const IconByType: Record<LocationTypes, TacticIconType> = {
  [LocationVariants.office]: OfficeIcon,
  [LocationVariants.dir]: FolderIcon,
  [LocationVariants.OOO]: OOOIcon,
  [LocationVariants.remote]: HomeIcon
} as const;

const DisplayedIcon = ({ type }: { type: LocationTypes }) => {
  const Icon = IconByType[type];
  return <Icon className="h-4 w-4 text-foreground" />;
};

export const FlatOfficeItem = React.forwardRef<
  React.ElementRef<typeof SelectPrimitive.Item>,
  Omit<SelectOfficeItemProps, "data"> & {
    type: LocationTypes;
    label: string;
    locationFilter: string;
    total_desks?: number;
    total_open_desks?: number;
  }
>(({ className, type, children, label, locationFilter, ...props }, ref) => {
  return (
    <SelectItem
      ref={ref}
      className={cn(
        "group relative flex w-full cursor-pointer select-none items-center",
        "bg-background px-4 py-1.5 text-sm outline-none",
        "focus:bg-gray-100",
        "transition-colors duration-200",
        "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        className
      )}
      skipSelectItemText={true}
      {...props}
    >
      {/* Show office icon when not selected */}
      <div className="-pt-0.5 -translate-y-1/2 absolute top-1/2 left-4 flex h-3.5 w-3.5 items-center justify-center group-data-[state=checked]:hidden">
        <DisplayedIcon type={type} />
      </div>

      <div className="flex w-full flex-row items-center justify-between gap-1">
        <div className="min-w-0 flex-1 pr-2 whitespace-normal break-words">
          <LabelWithHighlight label={label} highlight={locationFilter} />
        </div>

        {/* {type === LocationVariants.office && (
          <div className="ml-auto">
            <OccupancyIndicator
              totalSpaces={props.total_desks ?? 0}
              occupiedSpaces={props.total_open_desks ?? 0}
            />
          </div>
        )} */}
      </div>
    </SelectItem>
  );
});
